module.exports = __webpack_public_path__ + "static/media/departure-icon.d6f0fbbd.svg";